import styled, { css } from "styled-components";
import Link from "../UI/elements/Link";
import { theme } from "../../styles/theme/theme";
import { theme as checkoutTheme } from "../../styles/theme/checkoutTheme";

/* promo bar over the navbar */
export const Wrapper = styled.div<{ $paddingTop?: string; $paddingBottom?: string }>`
  ${theme.type.small}
  padding-left: 0.1em;
  padding-right: 0.1em;
  text-align: center;
  z-index: 20;
  /* z-index only works on a positioned box: keeps the bar above heroes pulled up under the navbar */
  position: relative;
  padding-top: ${(props) => props.$paddingTop ?? "0.3em"};
  padding-bottom: ${(props) => props.$paddingBottom ?? "1em"};
  overflow: hidden;
  background: ${(props) => props.color || theme.colors.white};
  max-height: 100px;
  //min-height: 75px;
  transition: max-height 1s ease-out;

  p {
    display: inline;
  }
`;

export const StaticWrapper = styled.div<{ $paddingTop?: string; $paddingBottom?: string; $color?: string }>`
  ${theme.type.small}
  padding-left: 0.3em;
  padding-right: 0.3em;
  text-align: center;
  z-index: 20;
  padding-top: ${(props) => props.$paddingTop ?? "0.3em"};
  padding-bottom: ${(props) => props.$paddingBottom ?? "1em"};
  overflow: hidden;
  background: ${(props) => props.$color || theme.colors.white};

  p {
    display: inline;
  }
`;

export const ContentWrapper = styled.div`
  text-align: center;
  padding: 0.5em 0;
  display: grid;
  place-items: center;
`;

export const ContentParagraph = styled.p<{ $color?: string }>`
  ${theme.type.small}
  color: ${(props) => props.$color || "#000"};
`;

export const Bold = styled.span`
  font-weight: ${theme.fonts.fontWeight.extraBold};
  color: inherit;
`;

export const DynamicMessage = styled.p<{ $applied?: boolean; $summary?: boolean; $backgroundColor?: string; $textColor?: string }>`
  font-weight: ${theme.fonts.fontWeight.extraBold};
  color: ${(props) => (props.$applied ? checkoutTheme.colors.promoColor : "unset")};
  text-transform: ${(props) => (props.$applied ? "uppercase" : "unset")};
  background-color: ${(props) => props.$backgroundColor || theme.colors.white};
  height: 2.75em;
  align-content: center;

  span:nth-child(1) {
    color: ${(props) => (props.$applied ? checkoutTheme.colors.promoColor : "unset")};
  }

  span:nth-child(2) {
    display: block;
    font-weight: ${theme.fonts.fontWeight.normal};
    text-transform: lowercase;
    font-style: italic;
  }

  ${({ $summary }) =>
    !$summary &&
    css`
      ${theme.type.promoBar}

      span:nth-child(1) {
        font-weight: inherit;
      }

      span:nth-child(2) {
        ${theme.type.small}
        font-weight: ${theme.fonts.fontWeight.normal};
        font-style: italic;
        color: ${theme.colors.titles};
      }
    `}

  ${({ $summary }) =>
    $summary &&
    css`
      ${theme.type.small}
      height: auto;
      margin: 0;
      padding: 0.625rem 0.75rem;
      border-radius: ${theme.radius.sm};
      background-color: ${theme.colors.gray};
      font-weight: normal;
      text-transform: none;

      && {
        color: ${theme.colors.primary};
      }

      && span {
        color: ${theme.colors.primary};
      }

      && span:nth-child(2) {
        color: ${theme.colors.titles};
      }
    `}
`;

/* holds the message's height until the cart loads: the same role, so the page does not jump when it appears */
export const PromoPlaceholder = styled.p`
  ${theme.type.promoBar}
  height: 2.75em;
`;

export const PromoLink = styled(Link)`
  cursor: pointer;
  margin-top: 1em;
  margin-right: 0.2em;
  margin-left: 0.2em;
  padding: 0.3em 0.7em;
  color: #fff;
  font-weight: ${theme.fonts.fontWeight.extraBold};
`;

export const InParagraphLink = styled(Link)`
  cursor: pointer;
  display: inline-block;
  margin-right: 0.5em;
  margin-left: 0.5em;
  border-bottom: 1px solid ${(props) => props.color};
  color: ${(props) => props.color || "#000"};
`;

export const SummaryMessages = styled.div`
  display: grid;
  gap: 0.5rem;
`;
